/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UpcomingSchedulePrefetchDtoApiResponse } from '../models/UpcomingSchedulePrefetchDtoApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ScheduleService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param withinHours
     * @param sedationistId
     * @param patientId
     * @returns UpcomingSchedulePrefetchDtoApiResponse Success
     * @throws ApiError
     */
    public getApiScheduleUpcomingPrefetch(
        withinHours?: number,
        sedationistId?: string,
        patientId?: string,
    ): CancelablePromise<UpcomingSchedulePrefetchDtoApiResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Schedule/upcoming-prefetch',
            query: {
                'WithinHours': withinHours,
                'SedationistId': sedationistId,
                'PatientId': patientId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
